import React from "react";
import { TableCell, TableRow } from "../../../design/table";
import type { Event } from "../../../models/Event";
import moment from "moment";
import EventTypeBadge from "../../../components/EventTypeBadge";
import EventSubtypeBadge from "../../../components/EventSubtypeBadge";
import { useEventType } from "../../../contexts/EventTypeContext";
import SlateTextArea from "../../../components/SlateTextArea/SlateTextArea";
import {
  CheckBadgeIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/20/solid";
import { EventService } from "../../../services/EventService";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../design/dropdown";
import { useEvent } from "../../../contexts/EventContext";
import EventCategoryBadge from "../../../components/EventCategoryBadge";

interface EventListItemProps {
  event: Event;
}

const EventListItem: React.FC<EventListItemProps> = ({ event }) => {
  const { deleteEventById } = useEvent();
  const { eventCategories, eventTypes, eventSubtypes } = useEventType();

  const handleVerify = async () => {
    await EventService.verifyEvent(event._id);
  };

  const handleDelete = async () => {
    await deleteEventById(event._id);
  };

  return (
    <TableRow key={event._id} href={`/event/${event._id}`}>
      <TableCell className="font-bold">
        <div className="flex items-center space-x-2">
          <span>
            {event.eventDate && moment(event.eventDate).format("LLL")}
          </span>
          {event.isVerified && (
            <CheckBadgeIcon
              className="w-4 h-4 text-green-600"
              title="Verified Event"
            />
          )}
        </div>
      </TableCell>

      <TableCell>
        <div className="flex flex-col space-y-1">
          <div className="flex flex-row space-x-2">
            {event.eventCategory && (
              <EventCategoryBadge
                eventCategoryId={event.eventCategory}
                eventCategories={eventCategories}
              />
            )}
            {event.eventType && (
              <EventTypeBadge
                eventTypeId={event.eventType}
                eventTypes={eventTypes}
              />
            )}
            {event.eventSubtype && (
              <EventSubtypeBadge
                eventSubtypeId={event.eventSubtype}
                eventSubtypes={eventSubtypes}
              />
            )}
          </div>
        </div>
      </TableCell>

      <TableCell>
        {event.content && (
          <SlateTextArea
            id={event._id}
            placeholder="Write a reply..."
            initialValue={[...JSON.parse(event.content)]}
            readOnly={true}
          />
        )}
      </TableCell>
      <TableCell>
        <Dropdown>
          <DropdownButton plain>
            <EllipsisHorizontalIcon className="w-4 h-4" />
          </DropdownButton>
          <DropdownMenu>
            {!event.isVerified && (
              <DropdownItem onClick={handleVerify}>Verify</DropdownItem>
            )}
            <DropdownItem href={`/event/${event._id}`}>Edit</DropdownItem>
            <DropdownItem onClick={handleDelete}>Delete</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </TableCell>
    </TableRow>
  );
};

export default EventListItem;
